import type { GameMeta } from '@gmp/game-sdk';

export const filibusterMeta = {
  id: 'filibuster',
  name: 'Filibuster',
  tagline: 'Talk as long as you can. No pauses. No ums. No mercy.',
  description:
    'Get a topic and talk. Go quiet for more than a second and a half and you are done; every "um" or "uh" costs more than the last. Play together, with teammates feeding you ideas and rivals throwing you off, or apart, each recording a video by the deadline.',
  minPlayers: 2,
  maxPlayers: 12,
  estimatedMinutes: [10, 25],
  usesMedia: true,
  modes: [
    { id: 'live', name: 'Live', description: 'Together in the room or on a call. Teammates send prompts, rivals send distractions.' },
    { id: 'remote', name: 'Remote', description: 'Everyone records a video on their own topic before the deadline, then reviews the others.' },
  ],
  theme: { primary: '#4cc9f0', secondary: '#ff4d6d', background: '#0b1324', ink: '#eef6ff' },
  readiness: 'beta',
  genre: 'Talk-without-stopping team game',
  controls: 'camera',
  category: 'party',
  instructions: [
    { icon: 'Mic', title: 'Talk', body: 'You get a topic. Tap start and talk about it for as long as you can. Your phone listens.' },
    { icon: 'Timer', title: 'Don\'t stop', body: 'Go quiet for more than 1.5 seconds and your filibuster ends. Your seconds are your points.' },
    { icon: 'AlertTriangle', title: 'No ums, no stalling', body: 'Your phone flags every "um" or "uh", drawn-out stalling ("sooooo…") and repeating yourself. Each fault costs double the last: 1, 2, 4, 8 seconds… Yield before it hurts.' },
    { icon: 'Users', title: 'Team up', body: 'Live: teammates send you ideas to talk about, rivals throw distractions and tap UM! when they hear one.' },
    { icon: 'Scale', title: 'Review', body: 'Everyone else checks the faults and can call foul if you read from a screen or recited a speech.' },
  ],
} satisfies GameMeta;
